import StepConnector, { StepConnectorIcon, stepConnectorClasses } from '@mui/material/StepConnector';
import { styled } from '@mui/material/styles';
import styles from './CustomConnector.module.scss'

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: '0.625rem',
    left: 'calc(-50% + 0.5rem)',
    right: 'calc(50% + 0.5rem)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: '#0070D8',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: '#4CAF50',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: '#D9E7F4',
    borderRadius: 1,
  },
}));

export default CustomConnector;
